module.exports = __webpack_public_path__ + "img/ban1-bg.5f004996.svg";